import { render, staticRenderFns } from "./ImgCard.vue?vue&type=template&id=6dbc1dc5&scoped=true&"
import script from "./ImgCard.vue?vue&type=script&lang=js&"
export * from "./ImgCard.vue?vue&type=script&lang=js&"
import style0 from "./ImgCard.vue?vue&type=style&index=0&id=6dbc1dc5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dbc1dc5",
  null
  
)

export default component.exports